import {
  Avatar,
  Box,
  Button,
  Container,
  Grid,
  IconButton,
  Paper,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { RouteUrls } from "../../../Constants/RouteUrls";
import { registrationFormData } from "./Data";
import { FormDataType } from "DataTypes/Form";
import { commonFormSwitch } from "Utils/SwitchCases";
import { HandleFormChange } from "Utils/Common";
// import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import ControlledForm from "Components/ControlledForm";
import authApi from "Service/Auth.api";
import ImgPath from "Constants/Imgs";
import { OrgDropArr } from "Constants/Arrays";

const validateEmail = (email: string): boolean => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

const NriRegister = () => {
  const navigate = useNavigate();
  const urlPath = window.location.pathname;
  const isCorporate = urlPath.includes(RouteUrls.corporate);
  const [formData, setFormData] = useState<FormDataType[]>([]);
  const [emailData, setEmailData] = useState<{
    fieldVal: string;
    otpSend: boolean;
    otpVal: string;
    otpVerified: boolean;
  }>({
    fieldVal: "",
    otpSend: false,
    otpVal: "",
    otpVerified: false,
  });
  const [contactData, setContactData] = useState<{
    fieldVal: string;
    otpSend: boolean;
    otpVal: string;
    otpVerified: boolean;
  }>({
    fieldVal: "",
    otpSend: false,
    otpVal: "",
    otpVerified: false,
  });
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
const [otpLoadingType, setOtpLoadingType] = useState<"email" | "contact" | null>(null);


  useEffect(() => {
    const newArr = JSON.parse(JSON.stringify(registrationFormData()));
    // if (isCorporate) {
    //   newArr.push({
    //     id: "organization",
    //     label: "Organization",
    //     boxType: "single-select-drop",
    //     validatetype: "dropdown",
    //     boxSize: 3,
    //     dropArr: OrgDropArr,
    //     placeholder: "Select Organization",
    //   });
    // }
    setFormData(newArr);
  }, []);

  const handleSendOtp: (otpType: "email" | "contact") => void = async (
    otpType
  ) => {

    if (otpType === "email") {
      if (!validateEmail(emailData.fieldVal)) return; // Extra safety

      if (!emailData.fieldVal || emailData.fieldVal.trim() === "") {
        alert("Please enter a valid email address first.");
        return;
      }
      setOtpLoadingType("email"); // Set loading for email only
      try {
        const res = await authApi.emailSendOtp({
          email: emailData.fieldVal,
          requestType: "register",
        });
        if (res?.success) {
          setEmailData({
            ...emailData, // Keep existing field value
            otpSend: true,
            otpVal: "",
            otpVerified: false,
          });
        }
      }
      catch (error) {
        console.error("Email OTP Error:", error);
      } finally {
        setOtpLoadingType(null); // Stop Loader
      }
  } 

  // else {
  //   if (!validatePhone(contactData.fieldVal)) return; // Extra safety
  //   setContactLoading(true);
  //   try {
  //     const res = await authApi.mobileSendOtp({ mobileNumber: contactData.fieldVal, requestType: "register" });
  //     if (res?.success) {
  //       setContactData({ ...contactData, otpSend: true, otpVal: "", otpVerified: false });
  //     }
  //   } finally {
  //     setContactLoading(false);
  //   }
  // }

    // if (otpType == "email") {
    //      // 1. Validation for Email
    // if (!emailData.fieldVal || emailData.fieldVal.trim() === "") {
    //   alert("Please enter a valid email address first.");
    //   return;
    // }
    // if (!/\S+@\S+\.\S+/.test(emailData.fieldVal)) {
    //   alert("Please enter a valid email format.");
    //   return;
    // }

    //  setOtpLoadingType("email"); // Set loading for email only

    // //   const res = await authApi.emailSendOtp({
    // //     email: emailData.fieldVal,
    // //     requestType: "register",
    // //   });
    // //   if (res?.success) {
    // //     setEmailData({
    // //       fieldVal: emailData.fieldVal,
    // //       otpSend: true,
    // //       otpVal: "",
    // //       otpVerified: false,
    // //     });
    // //   }

    //     try {
    //         const res = await authApi.emailSendOtp({
    //             email: emailData.fieldVal,
    //             requestType: "register",
    //         });
    //         if (res?.success) {
    //             setEmailData({
    //                 ...emailData, // Keep existing field value
    //                 otpSend: true,
    //                 otpVal: "",
    //                 otpVerified: false,
    //             });
    //         }
    //     }
    //     catch (error) {
    //         console.error("Email OTP Error:", error);
    //     } finally {
    //         setOtpLoadingType(null); // Stop Loader
    //     }






    // } 
    // else {
    //   const res = await authApi.mobileSendOtp({
    //     mobileNumber: contactData.fieldVal,
    //     requestType: "register",
    //   });
    //   if (res?.success) {
    //     setContactData({
    //       fieldVal: contactData.fieldVal,
    //       otpSend: true,
    //       otpVal: "",
    //       otpVerified: false,
    //     });
    //   }
    // }
  };
  const handleVerifyOtp: (otpType: "email" | "contact") => void = async (
    otpType
  ) => {
    if (otpType === "email") {
      const res = await authApi.verifyOtp({
        mobileNumber: null,
        email: emailData.fieldVal,
        otp: emailData.otpVal,
      });
      if (res?.success) {
        setEmailData({
          fieldVal: emailData.fieldVal,
          otpSend: true,
          otpVal: emailData.otpVal,
          otpVerified: true,
        });
      }
    } 
    // else {
    //   const res = await authApi.verifyOtp({
    //     mobileNumber: contactData.fieldVal,
    //     email: null,
    //     otp: contactData.otpVal,
    //   });
    //   if (res?.success) {
    //     setContactData({
    //       fieldVal: contactData.fieldVal,
    //       otpSend: true,
    //       otpVal: contactData.otpVal,
    //       otpVerified: true,
    //     });
    //   }
    // }
  };

  const handleRegister = async () => {
    // Define a default Date of Birth (e.g., 18 years ago)
  const defaultDOB = new Date(new Date().setFullYear(new Date().getFullYear() - 18)).toISOString();

    const payload = {
    firstName: formData[0]?.value ?? "",
    lastName: formData[1]?.value ?? "",
    password: formData[2]?.value ?? "", // Check index, usually password follows profile info
    address: formData[7]?.value ?? "Not Provided",
    city: formData[8]?.value ?? "",
    state: formData[4]?.value ?? "",
    postalCode: formData[5]?.value ?? "",
    dateOfBirth: formData[6]?.value ?? defaultDOB,
    description: formData[7]?.value ?? "",
    email: emailData?.fieldVal ?? "",
    ContactNumber: "0000000000", // Default placeholder

      // userType: "User",
    };

    const res = await authApi.registerNriUser(payload);
    if (res?.success) {
      navigate(`/${RouteUrls.login}`);
    }
  };

  const handlePasswordToggle = (fieldId: string) => {
    setFormData((prev) =>
      prev.map((field) =>
        field.id === fieldId
          ? { ...field, showPassword: !field.showPassword }
          : field
      )
    );
  };

//   return (
//     <Box sx={{ height: "100vh", overflow: "auto" }}>
//       <Box
//         sx={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "space-between",
//           px: 3,
//           py: 1,
//           borderBottom: "1px solid #e0e0e0",
//         }}
//       >
//         <Box
//           component="img"
//           src={"https://nolegalpaisa.com/assets/images/nlp_logo.png"}
//           alt="Logo"
//           sx={{
//             width: { xs: "150px", sm: "200px", md: "230px" },
//             height: { xs: "60px", sm: "80px", md: "83px" },
//             objectFit: "contain",
//             cursor: "pointer",
//             filter: "drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.3))",
//             transition: "transform 0.2s ease-in-out",
//             "&:hover": {
//               transform: "scale(1.05)",
//             },
//           }}
//           onClick={() => (window.location.href = "/home.html")}
//         />
//         <Typography
//           component="h1"
//           variant="h4"
//           sx={{
//             flex: 1,
//             textAlign: "center",
//             color: "primary.main",
//             fontWeight: 600,
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             gap: 1,
//           }}
//         >
//           <Avatar sx={{ m: 1, bgcolor: "primary.main" }}>
//             <LockOutlinedIcon />
//           </Avatar>
//           {"Sign Up"}
//         </Typography>
//         <Box sx={{ width: "180px" }} /> {/* Spacer to balance the layout */}
//       </Box>
//       <Grid
//         container
//         component="main"
//         sx={{ flex: 1 }}
//         alignItems="center"
//         justifyContent="center"
//       >
//         {!isSmallScreen && (
//           <Grid
//             sx={{
//               backgroundImage: 'url("/images/signup-bg.jpg")',
//               backgroundRepeat: "no-repeat",
//               backgroundSize: "cover",
//               backgroundPosition: "center",
//               height: "100%",
//             }}
//           />
//         )}
//         <Grid
//           sx={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             py: 4,
//           }}
//         >
//           <Box
//             sx={{
//               mx: 4,
//               width: "100%",
//               display: "flex",
//               flexDirection: "column",
//               alignItems: "center",
//             }}
//           >
//             <Box component="form" noValidate sx={{ mt: 1, width: "100%" }}>
//               <Grid mb={2} container columnSpacing={2} rowSpacing={2}>
//                 {formData.length > 0 &&
//                   formData.map((el: FormDataType) => (
//                     <Grid
//                       key={el.id}
//                       size={{ ...ControlledBoxSizeSwitch(el.boxSize) }}
//                     >
//                       {commonFormSwitch({
//                         formObj: {
//                           ...el,
//                           onPasswordToggle: el.hasPasswordToggle
//                             ? () => handlePasswordToggle(el.id)
//                             : undefined,
//                         },
//                         onChange: (data) =>
//                           setFormData(HandleFormChange(data, formData)),
//                       })}
//                     </Grid>
//                   ))}
//               </Grid>

//               <Grid container columnSpacing={2} rowSpacing={2}>
//                 <Grid key={"email"} size={{ ...ControlledBoxSizeSwitch(3) }}>
//                   <ControlledForm.Input
//                     id="email"
//                     value={emailData.fieldVal}
//                     label="Email"
//                     {...(emailData.otpVerified && {
//                       focused: true,
//                       borderColor: "success",
//                       readOnly: true,
//                     })}
//                     onChange={(value) =>
//                       setEmailData({ ...emailData, fieldVal: value as string })
//                     }
//                   />
//                 </Grid>
//                 <Grid
//                   key={"email"}
//                   sx={{ display: emailData.otpSend == true ? "block" : "none" }}
//                   size={{ ...ControlledBoxSizeSwitch(3) }}
//                 >
//                   <ControlledForm.Input
//                     id="emailOtp"
//                     label="Email OTP"
//                     {...(emailData.otpVerified && {
//                       iconId: "check-icon",
//                       infoText: "Email Verified",
//                       readOnly: true,
//                     })}
//                     value={emailData.otpVal}
//                     onChange={(value) =>
//                       setEmailData({ ...emailData, otpVal: value as string })
//                     }
//                   />
//                 </Grid>
//                 <Grid key={"email"} size={{ ...ControlledBoxSizeSwitch(3) }}>
//                   <Button
//                     // fullWidth
//                     variant="contained"
//                     sx={{ mt: 3 }}
//                     onClick={() =>
//                       emailData.otpSend
//                         ? handleVerifyOtp("email")
//                         : handleSendOtp("email")
//                     }
//                     disabled={emailData.otpVerified}
//                   >
//                     {emailData.otpSend === true ? "Verify" : "Send OTP"}
//                   </Button>
//                   <IconButton
//                     sx={{ mt: 3 }}
//                     title="Reset"
//                     onClick={() =>
//                       setEmailData(
//                         JSON.parse(
//                           JSON.stringify({
//                             fieldVal: "",
//                             otpSend: false,
//                             otpVal: "",
//                             otpVerified: false,
//                           })
//                         )
//                       )
//                     }
//                   >
//                     <ImgPath.RestoreIcon />
//                   </IconButton>
//                 </Grid>
//               </Grid>

//               <Button
//                 variant="contained"
//                 sx={{ mt: 3 }}
//                 onClick={ handleRegister}
//                 disabled={!emailData.otpVerified && !contactData.otpVerified}
//               >
//                 Sign Up
//               </Button>

//               <Typography
//                 sx={{
//                   textAlign: "center",
//                   textDecoration: "underline",
//                   cursor: "pointer",
//                   mt: 2,
//                 }}
//                 variant="body2"
//                 onClick={() => navigate(`/${RouteUrls.login}`)}
//               >
//                 Already have an account? Login
//               </Typography>
//             </Box>
//           </Box>
//         </Grid>
//       </Grid>
//     </Box>
//   );


// return (
//   <Box sx={{ 
//     height: "100vh", 
//     display: "flex", 
//     flexDirection: "column", 
//     bgcolor: "#f4f7f9" // Light neutral background
//   }}>
//     {/* --- MODERN MINIMAL HEADER --- */}
//     <Box
//       sx={{
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "space-between",
//         px: { xs: 2, md: 5 },
//         py: 2,
//         bgcolor: "white",
//         boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
//         zIndex: 10,
//       }}
//     >
//       <Box
//         component="img"
//         src={"https://nolegalpaisa.com/assets/images/nlp_logo.png"}
//         alt="Logo"
//         sx={{
//           width: { xs: "120px", md: "180px" },
//           cursor: "pointer",
//           transition: "0.3s",
//           "&:hover": { opacity: 0.8 }
//         }}
//         onClick={() => (window.location.href = "/home.html")}
//       />
//       <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//         <Typography variant="body2" color="text.secondary">Already have an account?</Typography>
//         <Button 
//             variant="outlined" 
//             size="small" 
//             onClick={() => navigate(`/${RouteUrls.login}`)}
//             sx={{ borderRadius: "20px", textTransform: "none" }}
//         >
//           Login
//         </Button>
//       </Box>
//     </Box>

//     {/* --- MAIN CONTENT AREA --- */}
//     <Grid container sx={{ flex: 1, overflow: "hidden" }}>
      
//       {/* LEFT SIDE: Visual Branding (Hidden on mobile) */}
//       {!isSmallScreen && (
//         <Grid 
//       size={{ md: 5, lg: 4 }} // Replacement for <Grid item md={5}>
//       sx={{
//         background: "linear-gradient(135deg, #1a237e 0%, #0d47a1 100%)",
//         display: "flex",
//         flexDirection: "column",
//         justifyContent: "center",
//         px: 6,
//         color: "white"
//       }}
//     >
//           <Typography variant="h3" color="text.secondary" fontWeight={700} gutterBottom>
//             Join our Global <br/> Legal Network.
//           </Typography>
//           <Typography variant="h6" color="text.secondary" sx={{ opacity: 0.8, fontWeight: 400, mb: 4 }}>
//             Secure, verified NRI registration for seamless legal assistance in India.
//           </Typography>
          
//           {/* Decorative Elements */}
//           <Box sx={{ 
//             p: 3, 
//             bgcolor: "rgba(255,255,255,0.1)", 
//             borderRadius: "15px", 
//             backdropFilter: "blur(10px)",
//             border: "1px solid rgba(255,255,255,0.2)"
//           }}>
//             <Typography variant="body2" color="text.secondary">✓ Verified Professional Drafting</Typography>
//             <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>✓ 256-bit Encrypted Security</Typography>
//             <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>✓ 24/7 NRI Support Access</Typography>
//           </Box>
//         </Grid>
//       )}

//       {/* RIGHT SIDE: The Form */}
//       <Grid 
//     size={{ xs: 12, md: 7, lg: 8 }} // Replacement for <Grid item xs={12}>
//     sx={{ 
//       overflowY: "auto", 
//       display: "flex", 
//       flexDirection: "column",
//       alignItems: "center",
//       pt: 4, 
//       pb: 8 
//     }}
//   >
//         <Box sx={{ width: "100%", maxWidth: "800px", px: { xs: 3, md: 8 } }}>
          
//           <Box sx={{ mb: 4 }}>
//             <Typography variant="h4" fontWeight={700} color="primary">NRI Registration</Typography>
//             <Typography variant="body1" color="text.primary">Please fill in your details to get started.</Typography>
//           </Box>

//           <Box component="form" noValidate>
//             {/* Dynamic Fields Section */}
//             <Grid container spacing={3}>
//               {formData.map((el: FormDataType) => (
//                 <Grid 
//     key={el.id} 
//     size={{ 
//       xs: 12, 
//       sm: el.boxSize === 3 ? 6 : 12, 
//       md: el.boxSize === 3 ? 6 : 12 
//     }}
//   >
//     {commonFormSwitch({
//       formObj: {
//         ...el,
//         onPasswordToggle: el.hasPasswordToggle 
//           ? () => handlePasswordToggle(el.id) 
//           : undefined,
//       },
//       onChange: (data) => setFormData(HandleFormChange(data, formData)),
//     })}
//   </Grid>
//               ))}

//               {/* Email Verification Section - Modernized */}
//               <Grid size={{ xs: 12, md: 7, lg: 8 }}>
//                 <Divider sx={{ my: 2 }}><Chip label="Identity Verification" size="small" /></Divider>
//               </Grid>

//               <Grid size={{ xs: 12, md: 7, lg: 8 }}>
//                 <ControlledForm.Input
//                   id="email"
//                   value={emailData.fieldVal}
//                   label="Registered Email Address"
//                   {...(emailData.otpVerified && {
//                     focused: true,
//                     borderColor: "success",
//                     readOnly: true,
//                   })}
//                   onChange={(value) => setEmailData({ ...emailData, fieldVal: value as string })}
//                 />
//               </Grid>

//               {emailData.otpSend && (
//                 <Grid size={{ xs: 12, md: 7, lg: 8 }}>
//                   <ControlledForm.Input
//                     id="emailOtp"
//                     label="Enter 6-Digit OTP"
//                     {...(emailData.otpVerified && {
//                       iconId: "check-icon",
//                       infoText: "Verified Successfully",
//                       readOnly: true,
//                     })}
//                     value={emailData.otpVal}
//                     onChange={(value) => setEmailData({ ...emailData, otpVal: value as string })}
//                   />
//                 </Grid>
//               )}

// {/* Verification Button Grid */}
// <Grid 
//   size={{ xs: 12, md: emailData.otpSend ? 3 : 4 }} 
//   sx={{ display: 'flex', gap: 1, alignItems: 'center' }}
// >
//   <Button
//     fullWidth
//     variant={emailData.otpSend ? "contained" : "outlined"}
//     color={emailData.otpVerified ? "success" : "primary"}
//     sx={{ height: "56px" }}
//     onClick={() => emailData.otpSend ? handleVerifyOtp("email") : handleSendOtp("email")}
//     disabled={emailData.otpVerified}
//   >
//     {emailData.otpVerified ? "Verified" : emailData.otpSend ? "Verify" : "Get OTP"}
//   </Button>
  
//   {emailData.otpSend && !emailData.otpVerified && (
//       <IconButton color="error" onClick={() => setEmailData({...emailData, otpSend: false, fieldVal: ""})}>
//         <ImgPath.RestoreIcon />
//       </IconButton>
//   )}
// </Grid>

// {/* Action Buttons Grid */}
// <Grid size={{ xs: 12 }} sx={{ mt: 4 }}>
//   <Button
//     fullWidth
//     variant="contained"
//     size="large"
//     onClick={handleRegister}
//     disabled={!emailData.otpVerified}
//     sx={{ 
//       py: 2, 
//       fontSize: "1.1rem", 
//       fontWeight: 600,
//       borderRadius: "8px",
//       boxShadow: "0 4px 14px 0 rgba(0,118,255,0.39)"
//     }}
//   >
//     Create My Account
//   </Button>
// </Grid>
//             </Grid>
//           </Box>
//         </Box>
//       </Grid>
//     </Grid>
//   </Box>
// );



return (
  <Box 
    sx={{ 
      minHeight: "100vh", 
      display: "flex", 
      flexDirection: "column",
      background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
      overflowY: "auto"
    }}
  >
    {/* --- MINIMALIST HEADER --- */}
    <Box sx={{ p: 3, display: "flex", justifyContent: "center" }}>
       <Box
          component="img"
          src={"https://nolegalpaisa.com/assets/images/nlp_logo.png"}
          alt="Logo"
          sx={{ height: "60px", cursor: "pointer" }}
          onClick={() => (window.location.href = "/home.html")}
        />
    </Box>

    <Container maxWidth="md" sx={{ pb: 8 }}>
      <Paper 
        elevation={0} 
        sx={{ 
          p: { xs: 3, md: 5 }, 
          borderRadius: 6, 
          boxShadow: "0px 20px 50px rgba(0,0,0,0.08)",
          bgcolor: "rgba(255, 255, 255, 0.9)",
          backdropFilter: "blur(10px)",
          border: "1px solid rgba(255, 255, 255, 0.3)"
        }}
      >
        {/* --- FORM TITLE --- */}
        <Box sx={{ textAlign: "center", mb: 4 }}>
          <Avatar 
            sx={{ 
              m: "0 auto 16px", 
              bgcolor: "primary.main", 
              width: 60, 
              height: 60,
              boxShadow: "0 8px 20px rgba(25, 118, 210, 0.2)"
            }}
          >
            {/* <PublicIcon fontSize="large" /> Changed to PublicIcon for NRI theme */}
          </Avatar>
          <Typography variant="h4" fontWeight={800} sx={{ color: "#1a202c", mb: 1 }}>
            NRI Registration
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Global legal assistance for Non-Resident Indians
          </Typography>
        </Box>

        <Box component="form" noValidate>
          <Grid container spacing={2.5}>
            
            {/* 1. DYNAMIC FIELDS */}
            {formData.length > 0 &&
              formData.map((el: FormDataType) => (
                <Grid 
                  key={el.id} 
                  size={{ xs: 12, sm: el.boxSize === 3 ? 6 : 12 }}
                >
                  {commonFormSwitch({
                    formObj: {
                      ...el,
                      onPasswordToggle: el.hasPasswordToggle
                        ? () => handlePasswordToggle(el.id)
                        : undefined,
                    },
                    onChange: (data) =>
                      setFormData(HandleFormChange(data, formData)),
                  })}
                </Grid>
              ))}

            {/* 2. VERIFICATION SECTION */}
            {/* <Grid size={12}>
              <Divider sx={{ my: 2 }}>
                <Typography variant="caption" sx={{ fontWeight: 700, color: "text.disabled", textTransform: "uppercase", letterSpacing: 1 }}>
                  Identity & Contact Verification
                </Typography>
              </Divider>
            </Grid> */}

            {/* --- EMAIL SECTION --- */}
            <Grid size={emailData.otpSend ? 7 : 9}>
              <ControlledForm.Input
                id="email"
                label="Email Address"
                error={emailData.fieldVal !== "" && !validateEmail(emailData.fieldVal)}
                infoText={emailData.fieldVal !== "" && !validateEmail(emailData.fieldVal) ? "Invalid email format" : ""}
                value={emailData.fieldVal}
                {...(emailData.otpVerified && { focused: true, borderColor: "success", readOnly: true })}
                onChange={(value) => setEmailData({ ...emailData, fieldVal: value as string })}
              />
            </Grid>
            {emailData.otpSend && (
              <Grid size={2}>
                <ControlledForm.Input
                  id="emailOtp"
                  label="OTP"
                  value={emailData.otpVal}
                  maxLength={4}
                  {...(emailData.otpVerified && { readOnly: true })}
                  onChange={(value) => setEmailData({ ...emailData, otpVal: value as string })}
                />
              </Grid>
            )}
            <Grid size={3} sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              <Button
                fullWidth
                variant={emailData.otpVerified ? "outlined" : "contained"}
                color={emailData.otpVerified ? "success" : "primary"}
                sx={{ height: '56px', borderRadius: 2, fontWeight: 600, textTransform: 'none' }}
                onClick={() => emailData.otpSend ? handleVerifyOtp("email") : handleSendOtp("email")}
                disabled={emailData.otpVerified || otpLoadingType === "email" || !emailData.fieldVal?.trim()}
              >
                {otpLoadingType === "email" ? "..." : emailData.otpVerified ? "Verified ✓" : emailData.otpSend ? "Verify" : "Get OTP"}
              </Button>
              <IconButton size="small" onClick={() => setEmailData({ fieldVal: "", otpSend: false, otpVal: "", otpVerified: false })}>
                <ImgPath.RestoreIcon fontSize="small" />
              </IconButton>
            </Grid>

            {/* --- CONTACT SECTION ---
            <Grid size={contactData.otpSend ? 7 : 9}>
              <ControlledForm.Input
                id="contact"
                label="Contact Number (with Country Code)"
                value={contactData.fieldVal}
                {...(contactData.otpVerified && { focused: true, borderColor: "success", readOnly: true })}
                onChange={(value) => setContactData({ ...contactData, fieldVal: value as string })}
              />
            </Grid>
            {contactData.otpSend && (
              <Grid size={2}>
                <ControlledForm.Input
                  id="contactOtp"
                  label="OTP"
                  value={contactData.otpVal}
                  {...(contactData.otpVerified && { readOnly: true })}
                  onChange={(value) => setContactData({ ...contactData, otpVal: value as string })}
                />
              </Grid>
            )}
            <Grid size={3} sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              <Button
                fullWidth
                variant={contactData.otpVerified ? "outlined" : "contained"}
                color={contactData.otpVerified ? "success" : "primary"}
                sx={{ height: '56px', borderRadius: 2, fontWeight: 600, textTransform: 'none' }}
                onClick={() => contactData.otpSend ? handleVerifyOtp("contact") : handleSendOtp("contact")}
                disabled={contactData.otpVerified || otpLoadingType === "contact" || !contactData.fieldVal?.trim()}
              >
                {otpLoadingType === "contact" ? "..." : contactData.otpVerified ? "Verified ✓" : contactData.otpSend ? "Verify" : "Get OTP"}
              </Button>
              <IconButton size="small" onClick={() => setContactData({ fieldVal: "", otpSend: false, otpVal: "", otpVerified: false })}>
                <ImgPath.RestoreIcon fontSize="small" />
              </IconButton>
            </Grid> */}

          </Grid>

          {/* --- FINAL ACTION BUTTON --- */}
          <Button
            fullWidth
            variant="contained"
            size="large"
            sx={{ 
              mt: 6, 
              py: 2, 
              borderRadius: 3, 
              fontSize: "1.1rem", 
              fontWeight: 700,
              textTransform: "none",
              boxShadow: "0 10px 25px rgba(25, 118, 210, 0.25)",
              transition: "0.3s",
              "&:hover": { transform: "translateY(-2px)", boxShadow: "0 15px 30px rgba(25, 118, 210, 0.3)" }
            }}
            onClick={handleRegister}
            disabled={!emailData.otpVerified}
          >
            Create NRI Account
          </Button>

          <Box sx={{ mt: 4, textAlign: "center" }}>
            <Typography variant="body2" color="text.primary">
              Already have an account?{" "}
              <Typography 
                component="span" 
                variant="body2" 
                onClick={() => navigate(`/${RouteUrls.login}`)}
                sx={{ color: "primary.main", fontWeight: 700, cursor: "pointer", "&:hover": { textDecoration: "underline" } }}
              >
                Sign In
              </Typography>
            </Typography>
          </Box>
        </Box>
      </Paper>
      
      <Typography variant="caption" sx={{ display: "block", textAlign: "center", mt: 4, color: "text.disabled" }}>
        Secure Registration for Global Indians. © 2025 NoLegalPaisa
      </Typography>
    </Container>
  </Box>
);

};

export default NriRegister;
